import React from "react";
import { Box, Divider } from "@mui/material";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { dt } from "../../../../shared/themes/redesignTokens";

interface CostBreakdown {
  label: string;
  value: number;
}

interface PricingSummaryProps {
  items: CostBreakdown[];
  total: number;
}

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-EU", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const PricingSummary = ({ items, total }: PricingSummaryProps) => {
  const { translate } = useTranslation(["serviceOffers"]);

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #F8FAFC 0%, #F0F4F8 100%)",
        border: `1px solid ${dt.cardBorder}`,
        borderRadius: dt.radiusSm,
        p: 2.5,
      }}
    >
      {items.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 0.75,
          }}
        >
          <Box
            sx={{
              fontFamily: dt.font,
              fontSize: "13px",
              color: dt.textSecondary,
            }}
          >
            {item.label}
          </Box>
          <Box
            sx={{
              fontFamily: dt.fontMono,
              fontSize: "13px",
              fontWeight: 500,
              color: dt.textPrimary,
            }}
          >
            {formatCurrency(item.value)}
          </Box>
        </Box>
      ))}

      <Divider sx={{ my: 1.5, borderColor: "#D1D5DB" }} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            fontFamily: dt.font,
            fontSize: "16px",
            fontWeight: 700,
            color: dt.textPrimary,
          }}
        >
          {translate("totalEstimatedCost")}
        </Box>
        <Box
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "20px",
            fontWeight: 700,
            color: dt.blue,
          }}
        >
          {formatCurrency(total)}
        </Box>
      </Box>
    </Box>
  );
};

export default PricingSummary;
